<template>
    <div v-if="items.length > 0" id="same-print-products" class="my-10 space-y-6">
        <ProductPageSlider :items="items" :arrow-step="2" track-class="-mx-2 -mb-8 scroll-px-2 gap-3 px-2 pt-1 pb-8">
            <template #header>
                <h2 class="text-left text-xl font-black md:text-2xl onlywow:md:text-4xl" v-text="$t('components.same_print_products.title')" />
            </template>

            <template #default="{ item }">
                <SamePrintProductCard
                    :item="item"
                    class="w-[calc((100%-0.75rem)/1.5)] shrink-0 sm:w-[calc((100%-3*0.75rem)/3)] lg:w-[calc((100%-3*0.75rem)/4)]"
                />
            </template>
        </ProductPageSlider>
    </div>
</template>

<script setup lang="ts">
import ProductPageSlider from '@/components/sliders/ProductPageSlider.vue';
import type { SamePrintProductObject } from '@/types/generated';
import SamePrintProductCard from './partials/SamePrintProductCard.vue';

defineProps<{
    items: SamePrintProductObject[];
}>();
</script>
